const BUTTON_LEFT = 0;
const BUTTON_MIDDLE = 1;

/**
 * Log info to console
 *
 * @param {any} args
 */
function logInfo(...args) {
    if (typeof window !== 'undefined' && window.console && window.console.info) {
        window.console.info.apply(console, args);
    }
}

/**
 * Log warning to console
 *
 * @param {any} args
 */
function logWarn(...args) {
    if (typeof window !== 'undefined' && window.console && window.console.warn) {
        window.console.warn.apply(console, args);
    }
}

/**
 * Log error to console
 *
 * @param {any} args
 */
function logError(...args) {
    if (typeof window !== 'undefined' && window.console && window.console.error) {
        window.console.error.apply(console, args);
    }
}

/**
 * Get nearest parent element matching selector
 * http://stackoverflow.com/questions/15329167/closest-ancestor-matching-selector-using-native-dom
 *
 * @deprecated since 2.1.2.
 * @param {*} el
 * @param {*} selector
 * @param {*} stop
 * @returns closest element based on inputs
 */
function closest(el, selector, stop) {
    const matchesSelector =
        el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
    let element = el;
    while (element) {
        if (matchesSelector.call(element, selector)) {
            break;
        } else if (stop && element === stop) {
            return null;
        }
        element = element.parentElement;
    }
    return element;
}

/**
 * Add event delegation to the given element.
 *
 * @deprecated since 2.1.2.
 * @param root The root element for delegation
 * @param event The event name to delegate
 * @param callback The callback function, will be passed the native event as the first
 *     argument, and the target element matching the selector as the second
 * @param selector The selector to match for the event
 */
function delegate(root, event, callback, selector) {
    function onDelegate(e) {
        const element = closest(e.target, selector, e.currentTarget);

        if (element) {
            callback(e, element);
        }
    }
    root.addEventListener(event, onDelegate);
}

/**
 * Check the node for the given data attribute. If the attribute exists
 * with the value of '!inherit', then it will search up the DOM until it
 * finds a parent with the data attribute.
 *
 * @deprecated since 2.1.2.
 * @method getDataAttribute
 * @private
 * @param {Node} node The node to search
 * @param {String} attr The data attribute to find, e.g. 'za-label'
 * @param {String} [defaultVal] A default value for the attribute
 * @return {String} The data attribute value, or undefined
 */
function getDataAttribute(node, attr, defaultVal) {
    const attrName = `data-${attr}`;
    let attrValue = defaultVal;
    let ancestor;

    if (node && node.hasAttribute(attrName)) {
        attrValue = node.getAttribute(attrName);
    }

    if (attrValue === '!inherit') {
        ancestor = closest(node.parentElement, `[${attrName}]`);
        return getDataAttribute(ancestor, attr);
    }

    return attrValue;
}

/**
 * Get the category from data attributes.
 *
 * @deprecated since 2.1.2.
 * @method getCategory
 * @private
 * @param {Node} node The node to get the value from
 * @return {String} The category string
 */
function getCategory(node) {
    return getDataAttribute(node, 'za-category');
}

/**
 * Get the action from data attributes.
 *
 * @deprecated since 2.1.2.
 * @method getAction
 * @private
 * @param {Node} node The node to get the value from
 * @return {String} The action string
 */
function getAction(node) {
    return getDataAttribute(node, 'za-action');
}

/**
 * Get the label from data attributes.
 *
 * @deprecated since 2.1.2.
 * @method getLabel
 * @private
 * @param {Node} node The node to get the value from
 * @return {String} The label string
 */
function getLabel(node) {
    return getDataAttribute(node, 'za-label');
}

/**
 * Parse the value integer from data attributes.
 *
 * @deprecated since 2.1.2.
 * @method getValue
 * @private
 * @param {Node} node The node to get the value from
 * @return {Int} The value integer, or undefined
 */
function getValue(node) {
    const value = getDataAttribute(node, 'za-value');
    return parseInt(value, 10) || undefined;
}

/**
 * Parse the noninteraction value from data attributes.
 *
 * @deprecated since 2.1.2.
 * @method getNoninteraction
 * @private
 * @param {Node} node The node to get the value from
 * @return {Boolean} The noninteraction value, or undefined
 */
function getNoninteraction(node) {
    const value = getDataAttribute(node, 'za-noninteraction');

    if (value === 'false') {
        return false;
    }

    if (value === 'true') {
        return true;
    }

    return undefined;
}

/**
 * Get the href from the data attribute or from anchor.
 *
 * @deprecated since 2.1.2.
 * @method getHref
 * @private
 * @param {Node} node The node to get the value from
 * @return {String} The href value
 */
function getHref(node) {
    const dataHref = getDataAttribute(node, 'za-href');

    if (typeof dataHref !== 'undefined' && dataHref !== null) {
        if (dataHref === '!ignore') {
            return '';
        }
        return dataHref;
    }
    if (node.hasAttribute('href')) {
        return node.getAttribute('href');
    }
    return undefined;
}

/**
 * Get ua dimension info from the data attribute of node (RE-8249)
 * Dimension 53: Event Details
 * Dimension 54: Event Content
 *
 * @deprecated since 2.1.2.
 * @method getDimensions
 * @private
 * @param {Node} node The node to get the value from
 * @return {Object} Object with key:value pairs that map to ua dimensions:values
 */
function getDimensions(node) {
    const dataEventDetailsIndex = '53';
    const dataEventDetails = getDataAttribute(node, 'za-event-details');
    const dataEventContentIndex = '54';
    const dataEventContent = getDataAttribute(node, 'za-event-content');
    const dimensions = {};

    if (dataEventDetails) {
        dimensions[dataEventDetailsIndex] = dataEventDetails;
    }

    if (dataEventContent) {
        dimensions[dataEventContentIndex] = dataEventContent;
    }

    return dimensions;
}

/**
 * Get the appropriate URL target, making sure to check for ctrl/middle
 * clicks that would open links in a new window.
 *
 * @deprecated since 2.1.2.
 * @method getTarget
 * @private
 * @param {Event} e
 * @param {Node} node The node that was clicked
 * @return {String} The URL target, or `undefined` if none is explicitly
 *     defined.
 */
function getTarget(e, node) {
    let target;

    if (e) {
        if (node) {
            // Data attribute takes precedence over anchor target
            target = getDataAttribute(node, 'za-target');
            if ((typeof target === 'undefined' || target === null) && node.hasAttribute('target')) {
                target = node.getAttribute('target');
            }
        }

        // Check for click behavior
        if (
            (e.button === BUTTON_MIDDLE && node.nodeName === 'A') ||
            (e.button === BUTTON_LEFT && e.ctrlKey) ||
            (e.button === BUTTON_LEFT && e.metaKey)
        ) {
            target = '_blank';
        }
    }
    return target;
}

/**
 * Sets Google Analytics integration on or off if not exists
 *
 * @param {boolean} gaEnabled is Google Analytics enabled?
 * @param {IOverrideOptions} options
 */
function setGAIntegrationIfNotExists(gaEnabled, options) {
    options = options || {};

    if (!('integrations' in options)) {
        options.integrations = {};
    }
    if (!('GaPlugin' in options.integrations)) {
        options.integrations.GaPlugin = gaEnabled;
    }
}

module.exports = {
    logWarn,
    logInfo,
    logError,
    delegate,
    getCategory,
    getAction,
    getLabel,
    getValue,
    getNoninteraction,
    getHref,
    getDimensions,
    getTarget,
    setGAIntegrationIfNotExists,
};
